/**
 * Jira Service Management exposes `jsdPublic` on comments from the REST API.
 * `false` = not visible on the customer portal (internal / agent note).
 * `true` = public on the portal. Undefined = not JSM or field omitted — do not assume internal.
 */
export function isJiraInternalComment(comment: { jsdPublic?: boolean }): boolean {
  return comment.jsdPublic === false;
}

/** Comments visible to customers (`jsdPublic !== false`). Omits JSM internal notes. */
export function filterPublicJiraComments<T extends { jsdPublic?: boolean }>(
  list: T[] | undefined | null
): T[] {
  if (!list?.length) return [];
  return list.filter((c) => !isJiraInternalComment(c));
}
